import React from 'react';
import { useSelector } from 'react-redux';

import gluLocale from '@glu/locale';
import { useTheme } from '@glu/theming';
import GluSideNav, { defaultStrings_en_US as navLocale } from '@glu/nav-react';

import useLocale from 'components/useLocale';
import Logo from './Logo';
import useStyles from './SideNav.styles';
import { ISideNavProps, ISideNavTheming } from './SideNav.types';

gluLocale.set(navLocale);

const SideNav = ({ navLinks }: ISideNavProps) => {
  const liveEngageKey = useSelector<{ auth: Record<string, any> }>(
    (state) => state?.auth?.liveEngageKey
  );
  const { nav } = useStyles({ hasLiveEngage: !!liveEngageKey });
  const locale = useLocale();
  const {
    images: {
      logos: {
        sideNav: { large, small }
      }
    }
  } = useTheme<ISideNavTheming>();
  return (
    <GluSideNav
      className={nav}
      closedLogo={<Logo src={small} alt={locale['sideNav.altText']} />}
      navLinks={navLinks}
      openLogo={<Logo src={large} alt={locale['sideNav.altText']} />}
      dataQa="side-nav"
      alwaysAllowClose
    />
  );
};

export default SideNav;
